// Module
var code = "<div ng-message=\"required\">Это поле является обязательным для заполнения</div>\n<div ng-message=\"pattern\">Значение не соответствует шаблону</div>\n<div ng-message=\"parentZay\">Дочерняя заявка не может быть родительской</div>\n<div ng-message-default>Данное поле содержит ошибку</div>";
// Exports
module.exports = code;